<template>
  <div class="ds-control mobile dsf_teas_student_wubie">
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      v-if="list.length > 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getList"
      >
        <div class="list">
          <div
            class="list-item"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="date">
              <!-- <div class="leftLine"></div> -->
              <div class="datetitle">
                {{ item.dateTime }} {{ item.weekStr }}
              </div>
            </div>
            <div class="atten-content">
              <div
                class="atten-item"
                v-for="(stuItem, stuindex) in item.studentNoons"
                :key="stuindex"
                @click="clickItem(stuItem)"
              >
                <div class="time">
                  <div class="label">{{ stuItem.noonText }}</div>
                  <div class="right">
                    <div
                      class="value"
                      :class="{
                        'text-green': stuItem.resultValue == '1' || stuItem.resultValue == '5',
                        'text-blue': '678'.indexOf(stuItem.resultValue) !== -1,
                        'text-red': '156789'.indexOf(stuItem.resultValue) === -1,
                        'text-grey': stuItem.resultValue == '9',
                      }"
                    >
                      {{ stuItem.resultText }}
                    </div>
                    <dsf-icon class="right-icon icon-weibiaoti34"/>
                  </div>
                </div>
                <!-- <div class="detail">
                <div class="row" v-if="stuItem.attendTime">
                  <div class="label">签到时间：</div>
                  <div class="value">{{ stuItem.attendTime }}</div>
                </div>
                <div class="row" v-if="stuItem.placeText">
                  <div class="label">签到地点：</div>
                  <div class="value">{{ stuItem.placeText }}</div>
                </div>
                <div class="row" v-if="stuItem.outAttendTime">
                  <div class="label">签退时间：</div>
                  <div class="value">{{ stuItem.outAttendTime }}</div>
                </div>
                <div class="row" v-if="stuItem.outPlaceValue">
                  <div class="label">签退地点：</div>
                  <div class="value">{{ stuItem.outPlaceValue }}</div>
                </div>
              </div> -->
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-empty v-else description="暂无数据" />
  </div>
</template>

<script>
const testData = [
  {
    dateTime: "2021-03-18",
    weekStr: "星期四",
    studentNoons: [
      {
        noonText: "下午",
        noonValue: "2",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "cf2768425be5446db02573b5712d525f",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
      {
        noonText: "晚上",
        noonValue: "3",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "58f5aaa34fd747eb824099b64bfef337",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
    ],
  },
  {
    dateTime: "2021-03-17",
    weekStr: "星期三",
    studentNoons: [
      {
        noonText: "上午",
        noonValue: "1",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "4a502b021d1341cbaa1b78b5ff8280a9",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
      {
        noonText: "下午",
        noonValue: "2",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "060a4b5e8ec8415e82980a972771a05b",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
    ],
  },
  {
    dateTime: "2021-03-16",
    weekStr: "星期二",
    studentNoons: [
      {
        noonText: "上午",
        noonValue: "1",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "de54a89bb6a5485d80435d9f47ac8112",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
      {
        noonText: "下午",
        noonValue: "2",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "b7d1f792c47e471b9c75c0c25e80c1ef",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
      {
        noonText: "晚上",
        noonValue: "3",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "8e138d612e91429fa792f4b4a4e161aa",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
    ],
  },
  {
    dateTime: "2021-02-28",
    weekStr: "星期日",
    studentNoons: [
      {
        noonText: "上午",
        noonValue: "1",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "4142b959dcad42f7a7be59a8b7b2702a",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
    ],
  },
  {
    dateTime: "2021-02-27",
    weekStr: "星期六",
    studentNoons: [
      {
        noonText: "上午",
        noonValue: "1",
        userId: "3a68db5d96f04d2cae0b0cd377fcbc33",
        relId: "6edce76212f54048bc8298c41f4f5dae",
        resultId: null,
        name: "测试学员",
        resultText: "未签",
        resultValue: "9",
        attendTime: null,
        placeText: null,
        placeValue: null,
        outAttendTime: null,
        outPlaceText: null,
        outPlaceValue: null,
      },
    ],
  },
];
import { scanCode } from "./utils";
export default dsf.component({
  name: "DsfMobileTeasStudentWubie",
  mixins: [$mixins.control],
  ctrlCaption: "午别考勤-学员",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "/teas/attendance/queryStudentNoonInfo",
    },
    scanCodeUrl: {
      type: String,
      default: "/teas/mobile/attendance/scanCodeAttend",
    },
    locationUrl: {
      type: String,
      default: "/teas/mobile/attendance/positioningAttendance",
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pageNum: 0,
      classId: "",
      list: [],
      attendInfor: {}, // 扫码考勤
    };
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.classId = dsf.getCookie("class_id");
      this.getList();
    }
    if (dsf.client.weixin() && window.$wx) {
      window.$wx.init();
    }
    // 获取考勤信息
    this.getAddanceInfor();
  },
  activated: function() {
    this.onRefresh();
  },
  methods: {
    // 点击方法
    clickItem(item) {
      if (this.isDesign) { 
        return;
      }
      if (this.$listeners["rowClick"]) {
        this.$dispatch("rowClick", item);
      } else {
        var url = '/mobile/teas/attendance/mobile/mobile-stuClassWubieAddanceDetail?relId=' + item.relId + '&type=2';
        this.$router.push({
          path: url
        })
      }
    },
    // 获取考勤类型及信息
    getAddanceInfor() {
      this.$http
        .get("teas/mobile/attendance/findAttendTypeInfo")
        .done((res) => {
          if (res.success && res.state == 20000) {
            this.attendInfor = res.data;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    // 获取列表数据
    getList(isRefresh = false) {
      // const loading = dsf.layer.loading();
      this.pageNum++;
      this.$http
        .post(this.sourcesUrl, {
          pageNum: this.pageNum,
          classId: this.classId,
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            if (isRefresh) {
              this.list = res.data.list;
            } else {
              this.list.push(...res.data.list);
            }
            this.finished = res.data.lastPage;
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
            this.finished = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
          this.finished = true;
        })
        .always(() => {
          this.loading = false;
          this.refreshing = false;
          // dsf.layer.closeLoading(loading);
        });
    },
    // 刷新
    onRefresh() {
      this.pageNum = 0;
      this.getList(true);
    },
  },
});
</script>